module.exports = __webpack_public_path__ + "static/img/fengjiao.5f0bcf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/medicines/fengjiao.jpg
// module id = V5V7
// module chunks = 1